import { useState, useEffect } from 'react';
import { X, Flame } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const STORAGE_KEY = 'referral-event-banner-dismissed';

export const ReferralEventBanner = () => {
  const [event, setEvent] = useState(null);
  const [dismissed, setDismissed] = useState(() => !!sessionStorage.getItem(STORAGE_KEY));
  const location = useLocation();

  useEffect(() => {
    axios.get(`${API}/referral-event`)
      .then(res => setEvent(res.data))
      .catch(() => setEvent(null));
  }, []);

  if (!event?.active || dismissed || location.pathname === '/admin') return null;

  return (
    <div className="bg-gradient-to-r from-[#7A1424] via-[#C41E3A] to-[#7A1424] text-white" data-testid="referral-event-banner">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 relative">
        <Flame size={15} className="text-[#FFD86B] flex-shrink-0" />
        <p className="text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-center">
          <span className="text-[#FFD86B]">2 for 1 Point Event</span> — every referral earns{' '}
          <span className="text-[#FFD86B]">2 points</span> toward your 100-point goal • 100 points ={' '}
          <span className="text-[#FFD86B]">20% OFF</span>
        </p>
        <button
          onClick={() => { setDismissed(true); sessionStorage.setItem(STORAGE_KEY, 'true'); }}
          className="absolute right-3 text-white/60 hover:text-white transition-colors"
          aria-label="Dismiss"
          data-testid="referral-event-banner-close"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default ReferralEventBanner;
